import type { AlertProps } from "@/ui/alert";

import classNames from "classnames";

import { Alert } from "@/ui/alert";

import "./form-item-alert.style.less";

export const FormItemAlert = ({ className, ...props }: AlertProps) => {
  return (
    <Alert
      display
      closable={false}
      className={classNames("form-item-alert", className)}
      {...props}
    />
  );
};
